import React, { ReactElement } from "react";
import topbarStyles from "./topbar.module.scss";
import { Dropdown } from "react-bootstrap";
import TopBarMenu from "./TopBarMenu";
import { useTranslation } from "react-i18next";
import Icon from "features/shared/components/icons/Icon";
import styles from "./languageDropdown.module.scss";
import { loadPortalConfig } from "features/shared/helpers/modules";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";

type Props = {
  className?: string;
};

const LanguageDropdown = ({ className }: Props) => {
  // translations
  const { i18n } = useTranslation();
  const tLangs = useTranslation("shared\\enums\\language").t;
  const tLabels = useTranslationWithPrefix(
    "shared\\components",
    "languageDropdown"
  );

  // props
  const languages = loadPortalConfig().enabledLanguages;

  // handlers
  const languageChangeHandler = (lang: string) => {
    i18n.changeLanguage(lang.toLowerCase());
  };

  // sub-renders
  const renderLanguages = (): ReactElement[] => {
    return languages.map((lang) => {
      return (
        <Dropdown.Item
          href="#"
          key={lang}
          onClick={() => languageChangeHandler(lang)}
          active={i18n.language === lang}
          className={styles.languageItem}
        >
          <span>
            <strong className="text-uppercase">{tLangs(`${lang}.code`)}</strong>
            <span> - </span>
            <span>{tLangs(`${lang}.title`)}</span>
          </span>
        </Dropdown.Item>
      );
    });
  };

  // render
  if (languages?.length > 1) {
    return (
      <Dropdown
        alignRight
        className={`${topbarStyles.topbarActionItem}${
          className ? ` ${className}` : ""
        }`}
      >
        <Dropdown.Toggle
          id="dropdown-languages-menu"
          className={`shadow-none ${topbarStyles.topbarActionLink}`}
        >
          <Icon icon="globe" />
        </Dropdown.Toggle>
        <TopBarMenu title={tLabels("language")}>{renderLanguages()}</TopBarMenu>
      </Dropdown>
    );
  } else {
    return null;
  }
};

export default LanguageDropdown;
